// Drawing one slide: the design for the post's job and family, on a clean
// canvas. Returns the tap targets (words and photos) for the editor.
import { createPainter } from './painter'
import { drawDesign } from './designs'
import { seasonalSrc } from '../kits/draw'

export const drawSlide = (ctx, env) => {
  const p = createPainter(ctx)
  ctx.save()
  ctx.clearRect(0, 0, env.W, env.H)
  drawDesign(p, env)
  ctx.restore()
  return p.boxes
}

// Every photo a post needs, to load before drawing, and a seasonal design's
// picture in both formats (it's shared in either)
export const imagesFor = (post, theme) => [
  ...Object.values(post.photos || {}).map(ph => ph && ph.src),
  ...['post', 'story'].map(format => seasonalSrc(post, theme, format)),
].filter(Boolean)
